export const FilmGrain = () => <div className="film-grain" aria-hidden="true" />;
